const SECTIONS = [
  ["1. General Information", [
    "The Weekend Edge provides horse-racing information, analysis, opinions and selections for informational and entertainment purposes only. Our content is not a guarantee of any race result or betting outcome.",
    "Horse racing involves uncertainty, and all selections carry a risk of losing money.",
  ]],
  ["2. No Guarantee of Results", [
    "Past performance, historical statistics, ratings, odds and previous tipping results do not guarantee future outcomes. Any confidence ratings or estimated probabilities represent analysis, not certainty.",
    "We do not guarantee winners, profits, returns or any particular level of performance.",
  ]],
  ["3. Independent Decisions", [
    "Users are responsible for their own decisions. You should independently verify race fields, scratchings, track conditions, odds and other relevant information before making any betting decision.",
  ]],
  ["4. Racing Data and Accuracy", [
    "Racing information may be delayed, incomplete, updated or corrected. We endeavour to maintain accurate information but do not guarantee that all information is complete or current at all times.",
  ]],
  ["5. Responsible Gambling", [
    "The Weekend Edge does not encourage anyone to gamble beyond their means. You must be at least 18 years old to use this website.",
    "HELP",
  ]],
  ["6. Limitation of Liability", [
    "To the extent permitted by applicable law, The Weekend Edge is not responsible for losses arising from reliance on racing analysis, selections, odds or other information published on this website.",
    "Nothing in these terms excludes any rights or remedies that cannot legally be excluded under Australian law.",
  ]],
  ["7. Changes", [
    "We may update this disclaimer as the website, its services or applicable requirements change. The latest version will be published on this website.",
  ]],
];

const Help = () => (
  <p>
    If gambling is causing harm to you or someone you know, seek support. In Australia, visit Gambling Help Online at{" "}
    <a href="https://www.gamblinghelponline.org.au" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline" data-testid="terms-gambling-help-link">gamblinghelponline.org.au</a>{" "}
    or call <a href="tel:1800858858" className="text-blue-400 hover:underline" data-testid="terms-gambling-help-phone">1800 858 858</a>.
  </p>
);

export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10" data-testid="terms-page">
      <p className="text-xs font-bold uppercase tracking-[0.3em] text-blue-400 mb-2">The Weekend Edge</p>
      <h1 className="text-4xl sm:text-5xl font-black uppercase tracking-tight mb-8">Terms & Conditions</h1>
      <div className="space-y-8">
        {SECTIONS.map(([title, paras]) => (
          <section key={title} className="rounded-2xl bg-[#131C31] border border-white/5 p-5 sm:p-6">
            <h2 className="font-display text-base md:text-lg font-bold mb-3">{title}</h2>
            <div className="space-y-3 text-sm sm:text-base text-slate-300 leading-relaxed">
              {paras.map((p) => (p === "HELP" ? <Help key={p} /> : <p key={p}>{p}</p>))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
